import { useEffect, useState } from 'react'
import { ReactComponent as SuccessSvg } from '../../../../assets/svg/success.svg'
import { ReactComponent as ConfettiDuotoneSvg } from '../../../../assets/svg/confetti-duotone.svg'

const SuccessScreen = ({ redirectUrl }) => {
  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    if (!redirectUrl) return

    if (countdown === 0) {
      window.location.replace(redirectUrl)
      return
    }

    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000)
    return () => clearTimeout(timer)
  }, [countdown, redirectUrl])

  return (
    <div
      style={{ minHeight: '450px' }}
      className='d-flex justify-content-center align-items-center'
    >
      <div style={{ maxWidth: '300px' }} className='w-100'>
        <SuccessSvg />

        <h5 className='fw-bold mb-4'>Money Sent!</h5>

        <div
          style={{
            border: '1px solid #EAECF0',
            background: '#FCFCFD',
            padding: '12px 20px',
          }}
          className='d-flex align-items-start rounded'
        >
          <ConfettiDuotoneSvg width={16} height={16} style={{ flexShrink: 0 }} />
          <p
            style={{ color: '#667085', fontSize: '12px' }}
            className='small flex-fill ml-1'
          >
            Your transaction is successful, you will be notified when the mandate
            is approved
          </p>
        </div>

        {redirectUrl && (
          <p
            style={{ color: '#667085', fontSize: '12px' }}
            className='text-center mt-3'
          >
            Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>
        )}
      </div>
    </div>
  )
}

export default SuccessScreen